module.exports = __webpack_public_path__ + "9c556d3d5b6803cd55d3e1f54c73cb55.png";